import React from "react";
import { Switch, Checkbox } from "antd";
import uploadimg from "../../assets/uploadicon.svg";
import eye from "../../assets/viewPdfEyeIcon.svg";
import { VIEW_ONLY_EMPTY_MESSAGE } from "../../hooks/useAdminPermissions";

const DpcExtraViewOnly = ({
  componentName = "",
  manageSwitch = false,
  onEnglishSwitch,
  onSpanishSwitch,
  activeStatus = false,
  url = "",
  phone = "",
  fileName = "",
  fileUrl = "",
  isTelemedicine = false,
  isVirtualCare = false,
  virtualCare = false,
}) => {
  const showVirtualCare = Boolean(isVirtualCare || virtualCare);
  const hasContactInfo = Boolean(url || phone);
  const hasFile = Boolean(fileName);
  const hasContent = isTelemedicine
    ? hasFile || showVirtualCare
    : hasContactInfo || hasFile;

  return (
    <>
      <div className="d-flex justify-content-end mb-30">
        <div className="switches-container mb-0">
          <div className="mempro" onClick={onEnglishSwitch}>
            English
          </div>
          <div className="mempro" onClick={onSpanishSwitch}>
            Spanish
          </div>
          <div
            className={
              !manageSwitch ? "switch-wrapper" : "switch-wrapper switchside"
            }
          >
            <div className="switch">
              {!manageSwitch ? <div>English</div> : <div>Spanish</div>}
            </div>
          </div>
        </div>
      </div>

      <div className="sectionpadding d-block mb-30 hoversection btnPosition dpc-extra-view-panel">
        <div className="d-flex justify-content-between align-items-center">
          <p className="mb-0 heedprodct">{componentName}</p>
          <Switch
            className="switches group-view-only-switch"
            checked={activeStatus}
            disabled
          />
        </div>
        <hr />

        {!isTelemedicine && hasContactInfo && (
          <div className="dpc-extra-view-info">
            <p className="dpc-extra-view-info-text mb-0">{url || "-"}</p>
            <span className="dpc-extra-view-info-divider" />
            <p className="dpc-extra-view-info-text mb-0">{phone || "-"}</p>
          </div>
        )}

        {isTelemedicine && showVirtualCare && (
          <div className="mb-30">
            <Checkbox checked disabled className="group-view-only-checkbox">
              Virtual Care ({manageSwitch ? "Spanish" : "English"})
            </Checkbox>
          </div>
        )}

        {hasFile ? (
          <div className="dpc-extra-view-file">
            <div className="dpc-extra-view-file-details">
              <img src={uploadimg} alt="" />
              <span>{fileName}</span>
            </div>
            {fileUrl ? (
              <a
                href={fileUrl}
                target="_blank"
                rel="noreferrer"
                className="dpc-extra-view-file-eye"
              >
                <img src={eye} alt="View file" />
              </a>
            ) : null}
          </div>
        ) : null}

        {!hasContent && (
          <p className="release-document-view-empty mb-0">{VIEW_ONLY_EMPTY_MESSAGE}</p>
        )}
      </div>
    </>
  );
};

export default DpcExtraViewOnly;
